module.exports = __webpack_public_path__ + "img/cp3-7.32b25183.jpg";